var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"gwapElement",attrs:{"id":"gwap-body"}},[_c('BlockFrame',{attrs:{"header":{title:_vm.appletData.name,icon:_vm.appletData.icon,more:true,code:'hyyd'}}},[_c('meetingReservation',{attrs:{"applet-data":_vm.appletData}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }